import React from 'react';
import { Button } from '@headlessui/react';
import { FaPlus } from 'react-icons/fa';

const LandingPageEmptyState = ({ 
  canCreateLandingPage, 
  onCreate 
}) => {
  return (
    <div className="text-center py-8 lg:py-12">
      <svg className="mx-auto h-10 w-10 lg:h-12 lg:w-12 text-gray-400 mb-3 lg:mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
      <h3 className="text-base lg:text-lg font-medium text-white mb-2">
        No landing pages yet
      </h3>
      <p className="text-gray-400 mb-4 lg:mb-6 text-sm lg:text-base">
        Get started by creating your first landing page
      </p>
      <div className="flex justify-center">
        <Button
          onClick={onCreate}
          className={`group flex items-center px-4 lg:px-6 py-2 lg:py-3 rounded-xl transition-all duration-200 data-hover:bg-gray-700 data-focus:ring-white border text-sm lg:text-base ${
            canCreateLandingPage 
              ? 'bg-gray-800 text-white hover:bg-gray-700 border-gray-700' 
              : 'bg-gradient-to-r from-indigo-600 to-purple-600 text-white hover:from-indigo-700 hover:to-purple-700 border-indigo-500 animate-pulse'
          }`}
        >
          <FaPlus className={`mr-1 lg:mr-2 h-3 w-3 lg:h-4 lg:w-4 transition-transform duration-200 ${
            canCreateLandingPage ? 'group-hover:rotate-90' : 'animate-bounce'
          }`} />
          <span className="hidden lg:inline">
            {canCreateLandingPage ? 'Create Landing Page' : 'Upgrade to Create More'}
          </span>
          <span className="lg:hidden">
            {canCreateLandingPage ? 'Create' : 'Upgrade'}
          </span>
        </Button>
      </div>
    </div>
  );
};

export default LandingPageEmptyState;
